import { assertNever } from "@impero-com/common/utils/obj";

import { useUserStatusQuery } from "../queries/useUserStatusQuery";

export function useDashboardRights(): boolean {
    const { data: userStatus } = useUserStatusQuery();
    const dashboardAccess = userStatus.frontendOptions.dashboardOverviewAccess;
    switch (dashboardAccess) {
        case "Full":
        case "ControlPrograms":
            return true;
        case "Limited":
            return false;
        default:
            return assertNever(dashboardAccess);
    }
}
